

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, rest), ["\n    ", h('g', {"fill":"none","fill-rule":"evenodd"}, ["\n        ", h('g', {"fill":"#111418"}, ["\n            ", h('path', {"d":"M12.803 4.136c.293-.293.768-.293 1.06 0 .267.267.291.683.073.977l-.072.084-6.667 6.667c-.266.266-.683.29-.977.072l-.084-.072L2.803 8.53c-.293-.293-.293-.767 0-1.06.266-.267.683-.29.977-.073l.084.073 2.802 2.803 6.137-6.137z"}, []), "\n        "]), "\n    "]), "\n"]);
};

        